import { get } from "./baseService";

import { extractToken } from "../helpers/utilities";

export async function getSettings() {
  let token = extractToken();
  const response = await get(`settings?api_token=${token}`, false);
  return response;
}
